import { useProperty } from '@eti/providers';
import SeatMapNewLayout from '../../seat-map-redesign-under-construction/containers/SeatMapContainer';
import SeatMap from './SeatMapContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const SeatMapWrapperContainer = _ref => {
  let {
    form,
    isSeatMapModalOpen,
    setIsSeatMapModalOpen,
    order,
    travelerLabel,
    isPostBooking,
    seatMapCallback,
    ...props
  } = _ref;
  const {
    p
  } = useProperty();
  const isNewSeatmapLayout = p('IbeClient.NewSeatmapLayout.Enabled');
  if (isNewSeatmapLayout) {
    return /*#__PURE__*/_jsx(SeatMapNewLayout, {
      callback: seatMapCallback,
      form: form,
      isPostBooking: isPostBooking,
      isSeatMapModalOpen: isSeatMapModalOpen,
      order: order,
      setIsSeatMapModalOpen: setIsSeatMapModalOpen,
      travelerLabel: travelerLabel
    });
  }
  return /*#__PURE__*/_jsx(SeatMap, {
    callback: seatMapCallback,
    form: form,
    isPostBooking: isPostBooking,
    isSeatMapModalOpen: isSeatMapModalOpen,
    order: order,
    seatMapCallback: seatMapCallback,
    setIsSeatMapModalOpen: setIsSeatMapModalOpen,
    travelerLabel: travelerLabel,
    ...props
  });
};
export default SeatMapWrapperContainer;
//# sourceMappingURL=SeatMapWrapperContainer.js.map